import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import classnames from 'classnames';

import CRMIssueForm from '@containers/crm/CRMIssueForm';

import ErrorPage from '@components/ErrorPage';

import './style.scss';

interface ICRMAppProps {}

interface ICRMAppState {}

class CRMApp extends React.PureComponent<ICRMAppProps, ICRMAppState> {
  constructor(props: ICRMAppProps) {
    super(props);

    document.title = 'Customer Relationship Management';
  }

  render() {
    return (
      <div className={classnames('crm-app')}>
        <Switch>
          <Route exact path="/crm/error" component={ErrorPage} />
          <Route exact path="/crm/:crmToken" component={CRMIssueForm} />
        </Switch>
      </div>
    );
  }
}

export default CRMApp;
